/* eslint-disable react/prop-types */
/* eslint-disable no-case-declarations */
import React from "react";
import "../../assets/styles/App.css";
import { Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { convertEpochToDate } from "../../utils/date";

/**
 * This component displays custom field data for both patient and exam
 * using the field definitions from session storage to show proper labels
 *
 * @component
 */
class CustomFieldsModal extends React.Component {
  constructor(props) {
    super(props);

    this.t = props.t;
    this.i18n = props.i18n;
  }

  /**
   * Parse custom fields data from JSON string
   */
  parseCustomFieldsData = customFieldsDataString => {
    try {
      return JSON.parse(customFieldsDataString || "{}");
    } catch (error) {
      //   console.error("Error parsing custom fields data:", error);
      return {};
    }
  };

  /**
   * Get custom field definitions from session storage
   */
  getCustomFieldDefinitions = () => {
    try {
      // Get the site data passed from parent component
      const { siteData } = this.props;

      if (
        !siteData ||
        !siteData.configurations ||
        !siteData.configurations.CUSTOM_FIELDS
      ) {
        return [];
      }

      // Find the CUSTOM_FIELDS configuration
      const customFieldsConfig = siteData.configurations.CUSTOM_FIELDS.find(
        config => config.name === "CUSTOM_FIELDS"
      );

      if (!customFieldsConfig || !customFieldsConfig.value) {
        return [];
      }

      // Parse the JSON string value
      return JSON.parse(customFieldsConfig.value);
    } catch (error) {
      // console.error("Error parsing custom fields definitions:", error);
      return [];
    }
  };

  /**
   * Format value based on field type
   */
  formatFieldValue = (value, fieldDefinition) => {
    if (!value && value !== 0) return "N/A";

    switch (fieldDefinition.type) {
      case "date":
        // Convert epoch timestamp to date
        return convertEpochToDate(parseInt(value));

      case "picker":
        // Find the display value for picker options
        const option = fieldDefinition.options?.find(
          opt => opt.value === value
        );
        return option ? option.display : value;

      case "number":
        return value;

      default:
        return value;
    }
  };

  /**
   * Render custom fields section
   */
  renderCustomFields = (customFieldsData, title, attributeType) => {
    const customFieldDefinitions = this.getCustomFieldDefinitions();
    const parsedData = this.parseCustomFieldsData(customFieldsData);

    // Filter fields by attribute type (patient or exam)
    const relevantFields = customFieldDefinitions.filter(
      field => field.attributeType === attributeType
    );

    if (relevantFields.length === 0) {
      return null;
    }

    return (
      <div className="custom-fields-section">
        <h6 className="section-title">{title}</h6>
        <div className="new-exam-details-patient-details demographic-details">
          {relevantFields.map(fieldDef => (
            <div key={fieldDef.id}>
              {fieldDef.label}:{" "}
              <span className="new-exam-details-value">
                {this.formatFieldValue(parsedData[fieldDef.id], fieldDef)}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const { patient, exam } = this.props;

    return (
      <div className="custommodal">
        <div className="custommodalinner abha-modal">
          <form className="loginpad">
            <h6 className="modal-heading">Custom Fields Data</h6>
            <Button onClick={this.props.closePopup} className="cancle">
              x
            </Button>
            <hr className="hrpadding" />

            {/* Patient Custom Fields */}
            {patient?.customFieldsData &&
              this.renderCustomFields(
                patient.customFieldsData,
                "Patient Information",
                "patient"
              )}

            {/* Exam Custom Fields */}
            {exam?.customFieldsData &&
              this.renderCustomFields(
                exam.customFieldsData,
                "Exam Information",
                "exam"
              )}

            {/* Show message if no custom fields data */}
            {!patient?.customFieldsData && !exam?.customFieldsData && (
              <div className="no-data-message">
                No custom fields data available
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomFieldsModal);
